/**
 * Created by chenrozenes on 07/08/2017.
 */

export const CANCER_SCREENING = 'CANCER_SCREENING';
export const CARE_OF = 'CARE_OF';
